import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class PropertyFeatureActivity extends Component {
	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/RealEstate/PropertyFeature/PropertyFeatureBrowser")
	}

	render() {
		return (
			<Activity 
				name="PropertyFeature"
				RenderedComponent={this.RenderedComponent}
				context="PropertyFeature"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(PropertyFeatureActivity)
